import { formatDateTime } from './utils';
import { postLog, getUserInfo } from '../service';
import LogStore from '../mobx/stores/log';

export const logStore = new LogStore();

const debug = false;

/**
 * @description 日志类
 * @export
 * @class Log
 */
export default class Log {
  constructor(options) {
    // 所有发送的数据的集合
    this.collector = [];
    this.preset = options || {
      mac: '',
      log_type: '2',
      frank_status: '30'
    };
    this.open = true;
    this.userInfo = null;
  }

  close() {
    this.open = false;
  }

  open() {
    this.open = true;
  }

  post(data, state) {
    // if (!this.open || process.env.NODE_ENV === 'develop') return Promise.resolve();

    // if (debug) {
    //   const time = formatDateTime(new Date());
    //   const formatTime = time.replace(/[\s:-]/g, '');
    //   const postData = Object.assign({}, {
    //     log_serial_number: this.preset.mac + formatTime,
    //     log_time: time,
    //     operator_account: 'test',
    //     operator_name: 'test',
    //   }, this.preset, data);

    //   this.collector.push(Object.assign({ state: 'success' }, postData));
    //   logStore.logs.push(Object.assign({ postState: 'success' }, postData));
    //   return true;
    // }
    return this.getUserInfo().then(() => {
      const time = formatDateTime(new Date());
      const formatTime = time.replace(/[\s:-]/g, '');
      const postData = Object.assign({}, {
        log_serial_number: this.preset.mac + formatTime,
        log_time: time,
        operator_account: this.userInfo.account,
        operator_name: this.userInfo.userName,
      }, this.preset, data);

      logStore.logs.push(Object.assign({ postState: state ? 'success' : 'fail' }, postData));
      // 测试环境不上传调试日志
      if (this.open && process.env.NODE_ENV !== 'develop') {
        postLog(postData).then(() => {
          this.collector.push(Object.assign({ postState: 'success' }, postData));
        }).catch(() => {
          this.collector.push(Object.assign({ postState: 'fail' }, postData));
        });
      }
    }).catch(error => console.log(error));
  }

  postData({
    operate,
    state,
    send = '',
    receive = '',
    receiveOrigin = '',
    count
  }) {
    this.post({
      log_content: `操作：${operate || ''}；状态：${state ? '成功' : '失败'}；发送：${send}；接收：${receive}；尝试次数：${count}；`,
      raw_content: `操作：${operate || ''}；状态：${state ? '成功' : '失败'}；发送：${send}；接收：${receiveOrigin}；尝试次数：${count}；`
    }, state);
  }

  postSuccess({
    operate,
    send = '',
    receive = '',
    receiveOrigin = '',
    count
  }) {
    this.postData({
      operate,
      state: true,
      send,
      receive,
      receiveOrigin,
      count
    });
  }

  postError({
    operate,
    send = '',
    error
  }) {
    this.postData({
      operate,
      state: false,
      send,
      receive: `状态码-${error.code || ''}，错误信息-${error.message}`,
      receiveOrigin: error.originData,
      count: error.count || -1
    });
  }

  getUserInfo() {
    if (this.userInfo) {
      return Promise.resolve(this.userInfo);
    }

    return getUserInfo().then((res) => {
      this.userInfo = {
        account: res.account,
        userName: res.userName
      };
      return this.userInfo;
    });
  }

  // 修改预置参数
  setPreset(options) {
    this.preset = Object.assign({}, this.preset, options);
  }

  setUserInfo(account, name) {
    this.userInfo = {
      account,
      userName: name
    };
  }
}
